// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2G67W","rootSmall":"AddTileButton_rootSmall__1l41Y"};